import axios from "../customAxios.js";
import { useNavigate } from "react-router-dom";
import {
  IconButton,
  TableCell,
  TableRow,
  Tooltip,
  Switch,
} from "@mui/material";

import { deliverySystemTranslate } from "../utils/functions";
import { mapStatus } from "../utils/functions";

function MailingRow(props) {
  const {
    mailing,
    columns,
    color,
    openCollapseTooltip,
    openCollapseIcon,
    fetchMailings,
  } = props;

  const navigate = useNavigate();

  const handleUpdateEnabled = async () => {
    try {
      await axios.put("mails/update_mailing_enabled/", {
        id: mailing["id"],
        is_active: !mailing["is_active"],
      });

      fetchMailings();
    } catch (error) {
      console.log(`Error al actualizar el estado del mailing: ${error}`);
    }
  };

  return (
    <>
      <TableRow
        sx={{ "& > *": { borderBottom: "unset" } }}
        style={{ backgroundColor: color }}
      >
        {columns.map((column, index) => {
          if (column.enabled) {
            if (column.columnName === "Acciones") {
              return (
                <TableCell key={`action-${index}`} className="actions-cell">
                  <div className="actions-container">
                    <Tooltip title={openCollapseTooltip} placement="top">
                      <IconButton
                        color="primary"
                        onClick={() => {
                          navigate("/home/mailing-config", {
                            state: {
                              mailId: mailing["id"],
                              mailStatus: mapStatus(mailing["status"]),
                              translatedDeliverySystem: deliverySystemTranslate(
                                mailing["delivery_system"]
                              ),
                            },
                          });
                        }}
                      >
                        {openCollapseIcon}
                        <p className="small-text mg-0 pd-l-10 purple-text">
                          Configurar mail
                        </p>
                      </IconButton>
                    </Tooltip>
                  </div>
                </TableCell>
              );
            } else {
              return (
                <TableCell
                  component="th"
                  scope="row"
                  key={`${column.columnName}-${index}`}
                >
                  {column.dbName === "is_active" ? (
                    <Switch
                      checked={mailing[column.dbName] === true}
                      onChange={() => handleUpdateEnabled()}
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  ) : column.dbName === "delivery_system" ? (
                    deliverySystemTranslate(mailing[column.dbName])
                  ) : column.dbName === "status" ? (
                    mapStatus(mailing[column.dbName])
                  ) : mailing[column.dbName] == null ? (
                    ""
                  ) : (
                    mailing[column.dbName]
                  )}
                </TableCell>
              );
            }
          }
        })}
      </TableRow>
    </>
  );
}

export default MailingRow;
